import assetService from "../../../../services/assetService/assetService";
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { CACHE_KEY_ASSETS } from "../../../../utils/constants";
import { DataSelectType } from "../../../../models/DataSelectType";
import { AssetInterface } from "../../../../models/AssetModel/Asset";

const useAssets = (
  page: number,
  pageSize: number,
  filters?: DataSelectType[]
) =>
  useQuery<AssetInterface[], Error>({
    queryKey: [
      CACHE_KEY_ASSETS,
      page > 0 ? page : null,
      pageSize > 0 ? pageSize : null,
      filters ?? null,
    ],
    queryFn: () => assetService.GetAll(page, pageSize, filters),
  });

export const useInfiniteAssets = (pageSize: number, filters?: DataSelectType[]) =>
  useInfiniteQuery<AssetInterface[], Error>({
    queryKey: [CACHE_KEY_ASSETS, "infinite", pageSize, filters ?? null],
    queryFn: ({ pageParam }) =>
      assetService.GetAll(pageParam as number, pageSize, filters),
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) =>
      lastPage.length < pageSize ? undefined : allPages.length + 1,
  });

export default useAssets;
